module.exports = __webpack_public_path__ + "static/media/PM119.5764193d.png";